module.exports = __webpack_public_path__ + "img/12_klio_07.0e049581.jpg";